import { shopPrefix } from '../../config';
import { http } from '../axios';

const endpoint = `${shopPrefix}/v1/subscription-management/products/:productId/expire`;

export const expireIssues = async (productId: string): Promise<void> => {
    return http.put<void>(endpoint, undefined, { pathParams: { productId } }).then();
};
